module.exports = __webpack_public_path__ + "static/13-0441b4212308c945d22448791e9cf324.jpg";